<div id="best-practices" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Best Practices</h2>

    <hr class="divider">

    <div class="row g-4 mt-3">
      <div class="col-md-4">
        <a routerLink="/iqac/best-prac/building-stronger-communities-through-education"
          class="info-card text-center d-block text-decoration-none">
          <h5 class="mb-0">Building Stronger Communities Through Education</h5>
        </a>
      </div>
      <div class="col-md-4">
        <a routerLink="/iqac/best-prac/go-green-initiative" class="info-card text-center d-block text-decoration-none">
          <h5 class="mb-0">Go Green</h5>
        </a>
      </div>
      <div class="col-md-4">
        <a routerLink="/iqac/best-prac/yoga-meditation" class="info-card text-center d-block text-decoration-none">
          <h5 class="mb-0">Yoga and Meditation</h5>
        </a>
      </div>
    </div>

    <!-- <div class="mt-5">
      <a href="https://shahsatnamjigirlscollege.com/wp-content/uploads/2025/03/public-disclosure-commitee-and-cells.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-file-pdf-o me-2"></i>Public Self-Disclosure (UGC)
      </a>
    </div> -->

  </div>
</div>